module.exports = __webpack_public_path__ + "assets/img/nlfg.9e0ca33a.png";